const app = angular.module('msi.oneTimeDifferences.oneTimeDifferencesWarningsController', []);

const quantityTemplateUrl = require('./views/quantity-differences-modal.html');
const shippingTemplateUrl = require('./views/shipping-differences-modal.html');
const billingTemplateUrl = require('./views/billing-differences-modal.html');

function oneTimeDifferencesWarningsControllerFactory($uibModal, dialogService, $document) {
  class OneTimeDifferencesWarningsController {
    openQuantityDifferencesExplanationModal() {
      return this._openOneTimeDifferenceExplanationModal(quantityTemplateUrl);
    }

    openShippingDifferencesExplanationModal() {
      return this._openOneTimeDifferenceExplanationModal(shippingTemplateUrl);
    }

    openBillingDifferencesExplanationModal() {
      return this._openOneTimeDifferenceExplanationModal(billingTemplateUrl);
    }

    _openOneTimeDifferenceExplanationModal(templateUrl) {
      const modal = $uibModal.open({
        templateUrl: templateUrl,
        controller: 'oneTimeDifferencesExplanationController',
        controllerAs: '$ctrl',
        resolve: { shipment: () => this.shipment },
        windowTopClass: 'og-one-time-difference-modal',
        ariaLabelledBy: 'og-one-time-difference-modals-title',
        ariaDescribedBy: 'og-one-time-difference-modals-description'
      });

      modal.rendered.then(() => $document[0].querySelector('.og-modal-window').setAttribute('aria-modal', true));

      modal.result.catch(dialogService.supressModalCloseReject);
    }
  }

  return new OneTimeDifferencesWarningsController();
}

oneTimeDifferencesWarningsControllerFactory.$inject = ['$uibModal', 'dialogService', '$document'];

app.controller('oneTimeDifferencesWarningsController', oneTimeDifferencesWarningsControllerFactory);

module.exports = app.name;
